import { type Feature, FeatureType } from '@/app/components/search/components/EvolutionCard/utils/facilitiesTypes.ts';
import {
  getActiveFacilities,
  getIcon,
  getText,
} from '@/app/components/search/components/EvolutionCard/utils/facilitiesUtils.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation.tsx';
import { FACILITIES } from '@/app/components/search/utils/FacilitiesType.ts';
import type { ProductAccommodationFacilities } from '@/domainLogic/types/typesProduct.ts';

// const blacklisted = ['disableGuest'];

export const getFacilities = ({
  facilities,
  max,
  t,
  hasChildren,
}: {
  facilities: ProductAccommodationFacilities;
  imageBasePath: string;
  max: number;
  t: TranslationFunction;
  hasChildren: boolean;
}): Feature[] => {
  const allowedFacilities = [
    FACILITIES.SEAFRONT,
    FACILITIES.SPA,
    FACILITIES.SWIMMING_POOL,
    FACILITIES.PARKING,
    FACILITIES.FREE_WIFI,
    ...(hasChildren ? [FACILITIES.CHILDREN] : [FACILITIES.ADULTS_ONLY]),
    FACILITIES.ENTERTAINMENT,
    FACILITIES.PETS_ALLOWED,
    FACILITIES.KITCHEN,
  ];

  const features = getActiveFacilities(facilities, allowedFacilities);
  const limitedFeatures = features.slice(0, max);

  // No separator: each facility is a row of its own on the Evo card.
  return limitedFeatures.map((facility: FACILITIES) => ({
    icon: getIcon(facility),
    text: getText(facility, t) as string,
    className: 'facilities',
    featureType: FeatureType.normal,
  }));
};
